import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/recommendation/title_image.png'
import _imports_1 from '../../assets/recommendation/manual-01_kv.gif'
import _imports_2 from '../../assets/recommendation/manual-02_img1.png'
import _imports_3 from '../../assets/recommendation/manual-02_img2.png'


const _hoisted_1 = {
  class: "main",
  id: "main"
}
const _hoisted_2 = { class: "wrap__manual" }
const _hoisted_3 = { class: "header__manual" }
const _hoisted_4 = { class: "section_inner__manual" }
const _hoisted_5 = { class: "contents__manual is-color-purple" }
const _hoisted_6 = { class: "section__manual section__manual__mv" }
const _hoisted_7 = { class: "inner__manual" }
const _hoisted_8 = { class: "mv__manual" }
const _hoisted_9 = { class: "section__manual section__manual__default section__manual__colored" }
const _hoisted_10 = { class: "img__manual" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              class: "img__header__manual header-title-margin",
              onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
              src: _imports_0,
              alt: ""
            }, null, 32)
          ]),
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              class: "img__header__manual",
              onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
              src: _imports_1,
              alt: ""
            }, null, 32)
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text__manual" }, "『使い方サポート』のお知らせでお届けするコンテンツは、みなさまのスマホ利用に役立つヒントを数多く盛り込み、通信やテクノロジーとともにある日々の暮らしをサポートします。ここでは、その一例となるコンテンツをご紹介します。", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("section", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "ttl__h1__manual" }, "上手にスマホで撮影するなら基本の写真テク「三分割法」", -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                onLoad: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
                src: _imports_2,
                alt: ""
              }, null, 32)
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "txt__manual" }, "被写体を中央に置いてしまい、どこか味気ない写真に毎回なってしまう…。スマートフォンでも写真の基本はかわりません。一歩グレードアップさせるなら「三分割法」をマスターするのがおすすめです。", -1))
          ])
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("section", { class: "section__manual section__manual__default" }, [
          _createElementVNode("div", { class: "inner__manual" }, [
            _createElementVNode("h2", { class: "ttl__h2__manual" }, [
              _createTextVNode("初心者でもプロ級になる"),
              _createElementVNode("br"),
              _createTextVNode("「三分割法」とは？")
            ]),
            _createElementVNode("p", { class: "txt__manual" }, "三分割法とは写真の基本的な構図のひとつ。スマートフォンのカメラには、設定により三分割法に用いる格子線＝グリッドラインを表示する機能もあります。このグリッドラインを被写体の配置目安にすると絶妙なバランスの写真撮影ができて、「これ、プロに撮ってもらったの？」と評価されるかもしれませんよ。")
          ])
        ], -1)),
        _createElementVNode("section", _hoisted_9, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "arrow_box" }, [
            _createTextVNode("まずは実践！"),
            _createElementVNode("br"),
            _createTextVNode("ゲーム感覚で三分割法を体験してみよう！")
          ], -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              onLoad: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
              src: _imports_3,
              alt: ""
            }, null, 32)
          ]),
          _createElementVNode("div", {
            class: "conversion__btn__manual",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotoInteractive()))
          }, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("a", { href: "" }, "チャレンジ", -1)
          ]))])
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("section", { class: "footer__manual" }, [
        _createElementVNode("div", { class: "section_inner__manual" }, [
          _createElementVNode("h2", { class: "ttl__manual" }, "スマホの楽しさ、もっと広がる。"),
          _createElementVNode("p", null, "このように、これから始まる新しいスマートフォンとの生活をより楽しく、より快適にしてくれるヒントをさまざまな記事でご紹介していきます。【使い方サポート】がお届けするコンテンツの代表例をはじめ、あなたの暮らしがより快適になる今後の出会いにご期待ください。")
        ])
      ], -1))
    ])
  ]))
}